import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            // Short delay so user isn't immediately bombarded
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'accepted');
        setIsVisible(false);
        // Trigger analytics if enabled
        if (window.gtag && process.env.REACT_APP_GA_MEASUREMENT_ID) {
            window.gtag('consent', 'update', {
                analytics_storage: 'granted',
            });
        }
    };

    const handleDecline = () => {
        localStorage.setItem('cookie_consent', 'declined');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div
            role="region"
            aria-label="Cookie consent banner"
            className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md bg-[#111a2e] border border-slate-800 rounded-lg shadow-2xl p-5 z-50"
        >
            <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2">
                    <span className="text-xl" role="img" aria-label="Cookie">🍪</span>
                    <h3 className="text-gray-100 font-semibold text-base">Cookie Preferences</h3>
                </div>
                <p className="text-sm text-gray-300 leading-relaxed">
                    This website uses cookies to enhance your experience and analyze site traffic. Read the{' '}
                    <Link to="/privacy" className="text-[#64ffda] hover:underline">
                        Privacy Policy
                    </Link>{' '}
                    for details.
                </p>
                <div className="flex items-center justify-end gap-3 pt-2">
                    <button
                        onClick={handleDecline}
                        className="px-4 py-2 text-xs font-medium text-gray-300 hover:text-white border border-gray-600 hover:border-gray-400 rounded transition-colors"
                    >
                        Decline
                    </button>
                    <button
                        onClick={handleAccept}
                        className="px-4 py-2 text-xs font-semibold bg-[#64ffda] hover:bg-[#4fe3c1] text-[#0b1120] rounded transition-colors"
                    >
                        Accept All
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
